// extracted by mini-css-extract-plugin
export default {"holSocialMediaIcons":"_3qGCCN6yznIy1TGu3zPCv9","holSocialMediaIconsTwitter":"_3_6-xEKi0t7yGFnwtKzt74","molSocialMediaIconsTwitter":"_2s6TDtpwmxT8lyEmPQ-221"};